import type { JSX } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Renders assistant answer text as markdown (GFM: lists, tables, bold, headings,
 * code). react-markdown does not render raw HTML by default, so this is
 * XSS-safe for model output. Styled via the `.md` block in chat.css using the
 * cycledesign type scale. Partial markdown re-parses each streaming delta.
 */
export function Markdown({ children }: { children: string }): JSX.Element {
  return (
    <div className="md">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children: c }) => (
            <a href={href ?? "#"} target="_blank" rel="noopener noreferrer">
              {c}
            </a>
          )
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
